import React from 'react';
import NativeSelect from '@mui/material/NativeSelect';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Field, formValueSelector } from 'redux-form';

const selector = formValueSelector('from-tableComponent');

const isSameTag = (item, value) => String(item.code) === String(value) || String(item.id) === String(value);

const renderSelect = ({ input, meta: { touched }, placeholder, options, rowTouched, ...custom }) => {
    const isError = !input.value && (touched || rowTouched);
    return (
        <NativeSelect
            {...input}
            {...custom}
            error={isError}
            sx={{
                minWidth: '200px',
                ...(isError && {
                    color: 'error.main',
                    '& .MuiNativeSelect-select': { color: 'error.main' },
                    '&::before': { borderBottomWidth: '2px' },
                }),
            }}
        >
            <option value="">{placeholder}</option>
            {options.map(item => (
                <option key={item.id} value={item.code}>
                    {item.label}
                </option>
            ))}
        </NativeSelect>
    );
};

export default ({ code, id }) => {
    const { t } = useTranslation();
    const tags = useSelector(state => state.groups && state.groups.promoTags);
    const isPromoPresent = useSelector(state => selector(state, JSON.stringify({ code: 'isPromoPresent', id })));
    const value = useSelector(state => selector(state, JSON.stringify({ code, id })));

    const all = tags || [];
    const options = all.filter(item => !!item.is_present === (isPromoPresent === true));
    const current = value ? all.find(item => isSameTag(item, value)) : null;
    const list = current && !options.some(item => item.id === current.id) ? [current, ...options] : options;
    const rowTouched = isPromoPresent === true || isPromoPresent === false;

    return (
        <Field
            name={JSON.stringify({ code, id })}
            placeholder={t('promoVisits.selectAnswer')}
            rowTouched={rowTouched}
            options={list.map(item => ({ id: item.id, code: item.code, label: t(`promo_tag.${item.code}`) }))}
            component={renderSelect}
            type="text"
        />
    );
};
